// extracted by mini-css-extract-plugin
export var chevron = "_kr-2";
export var chevronRotated = "_kr-3";
export var header = "_kr-1";
export var section = "_kr-0";